// extracted by mini-css-extract-plugin
module.exports = {"termsOfServiceContainer":"SrListingTermsOfService--termsOfServiceContainer--3wX2T","highlightYellowFadeIn":"SrListingTermsOfService--highlightYellowFadeIn--3i7vG"};